import { Indicator } from '../../../Common/Charts/Indicator';
import { useMortalityMobidityChartsDataContext } from './hooks/useMortalityMobidityChartsDataContext';

export const TenagerMothers = () => {
    const { chartData } = useMortalityMobidityChartsDataContext();


    return (
        <Indicator
            title={'Mães Adolescentes (menor de 18 anos)'}
            indicatorValue={chartData?.indicators?.tenagerMothers}
            className='aligned-container'
             goalMessage="Meta Aceitável - 20 a cada 10000"
        />
    );
};
